"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../ThemeProvider");

var _scoreColor = _interopRequireDefault(require("../../utils/scoreColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Balloon =
/*#__PURE__*/
function (_Component) {
  _inherits(Balloon, _Component);

  function Balloon() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Balloon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Balloon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "noScore", function () {
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_this.props.theme.innerCircle, _this.props.theme.noScore)
      }, _react["default"].createElement("span", null, "No Score"));
    });

    _defineProperty(_assertThisInitialized(_this), "hasScore", function () {
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_this.props.theme.outerCircle, _defineProperty({}, _this.props.theme.displace, _this.props.shouldDisplace))
      }, _react["default"].createElement("div", {
        className: _this.props.theme.innerCircle,
        style: {
          backgroundColor: (0, _scoreColor["default"])(_this.props.score)
        }
      }, _this.props.score));
    });

    return _this;
  }

  _createClass(Balloon, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", null, this.props.score ? this.hasScore() : this.noScore());
    }
  }]);

  return Balloon;
}(_react.Component);

_defineProperty(Balloon, "propTypes", {
  score: _propTypes["default"].number,
  theme: _propTypes["default"].shape({
    noScore: _propTypes["default"].string,
    outerCircle: _propTypes["default"].string,
    displace: _propTypes["default"].string,
    innerCircle: _propTypes["default"].string
  }).isRequired,
  shouldDisplace: _propTypes["default"].bool
});

_defineProperty(Balloon, "defaultProps", {
  score: 0,
  shouldDisplace: false
});

var _default = (0, _ThemeProvider.applyTheme)('Balloon', Balloon);

exports["default"] = _default;